/** Scheduled consultation length (informational only — the call is not auto-ended). */
export const SESSION_DURATION_MINUTES = 20;

/** Show the advisory when this many minutes remain in the scheduled window. */
export const FINAL_WINDOW_MINUTES = 5;

export const REMINDER_AT_ELAPSED_MINUTES = SESSION_DURATION_MINUTES - FINAL_WINDOW_MINUTES;

/** Test mode: show the 5-minute advisory after this many minutes elapsed. */
export const TEST_REMINDER_AFTER_MINUTES = 1;

export const SESSION_START_TIME_KEY = 'VideoNewApp-sessionStartTime';
export const REMINDER_SHOWN_KEY = 'VideoNewApp-reminderShown';

export function sessionStartStorageKey(roomId: string): string {
  return `${SESSION_START_TIME_KEY}:${roomId}`;
}

export function reminderShownStorageKey(roomId: string): string {
  return `${REMINDER_SHOWN_KEY}:${roomId}`;
}

export function formatClockDuration(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export type SessionTimerUserType = 'doctor' | 'patient';

export function getSessionReminderCopy(userType: SessionTimerUserType): { headline: string; message: string } {
  if (userType === 'doctor') {
    return {
      headline: 'Consultation time notice',
      message:
        'Approximately 5 minutes remain in this scheduled 20-minute consultation. Please begin wrapping up your discussion and confirm follow-up plans with your patient. The video visit will stay connected if you need additional time.',
    };
  }

  return {
    headline: 'Consultation time notice',
    message:
      'Approximately 5 minutes remain in this scheduled 20-minute consultation. Please finish your questions and review any instructions from your physician. The video visit will stay connected if you need additional time.',
  };
}
